import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment as ENV } from '../../environments/environment';
import { ApiEndpoints as API } from '../../config/api-endpoints';
import { IEmail } from "../shared/models/email.interface";
import { retry } from "rxjs/operators";
import { AccountInfo } from "../shared/models/account-info.interface";

@Injectable()
export class AccountService {

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(
    private http: HttpClient
  ) { }

  public checkRoleUsers(policyNumber: string): Observable<any>{
    const endpoint2 = ENV.baseUrl.api + API.checkRoleUsers;
    return this.http.post<any>(endpoint2, { 'policyNumber': policyNumber }, this.httpOptions);
  }

  sendVerificationCodeEmail(email: IEmail) {
    email.CountryLocale = sessionStorage.getItem('locale');
    return this.http.post(`${ENV.baseUrl.api}${API.CREATE_ACCOUNT}`, email, this.httpOptions).pipe(
      retry(3)
    );
  }

  //Policy Search API but without Auth, so no actual policy info is returned
  public policyCheck(policyNumber: string, zipCode: string): Observable<any>{
    let id = policyNumber;
    let zip = zipCode;
    return this.http.get<any>(`${ENV.baseUrl.api}${API.getPolicyDetailsNoAuth}?policyNumber=${id}&zip=${zip}`, this.httpOptions);
  }

  public validateVerificationCode(verifyDetails){
    return this.http.post<any>(`${ENV.baseUrl.api}${API.tupssVerify}`, verifyDetails, this.httpOptions);
  }

  public MailResetPassword(email: IEmail): Observable<any>{
      email.CountryLocale = sessionStorage.getItem('locale');
    return this.http.post<any>(`${ENV.baseUrl.api}${API.RESET_PASSWORD}`, email, this.httpOptions);
  }

  public changePassword(): Observable<any> {
    return this.http.post<any>(`${ENV.baseUrl.api}${API.CHANGE_PASSWORD}`, this.httpOptions);
  }

  saveUserSettings(user: AccountInfo): Observable<any> {
    return this.http.post(`${ENV.baseUrl.api}${API.UPDATE_USER_PREFERENCES}`, user, this.httpOptions).pipe(retry(3));
  }

  updateContact(updateContactRequest: any): Observable<any> {
    return this.http.post(`${ENV.baseUrl.api}${API.POLICY_UPDATE_CONTACT}`, updateContactRequest, this.httpOptions).pipe(retry(3));
  }

  retrieveCRMData(payload: any): Observable<any> {
    return this.http.post(`${ENV.baseUrl.api}${API.GET_CRM_DATA}`, payload, this.httpOptions).pipe(retry(3));
  }

  verifyCRMProspect(payload: any): Observable<any> {
    return this.http.post(`${ENV.baseUrl.api}${API.VERIFY_CRM_PROSPECT}`, payload, this.httpOptions);
  }

  //Internal user logs 2025
  public uiLogInternalUser(user): Observable<any>{
    return this.http.post<any>(`${ENV.baseUrl.api}${API.UILOG_INTERNAL_USER}`, user, this.httpOptions);
  }

  storePasswordlessToken(request: {id_token: string, workflow: string, email?: string} ) {
    return this.http.post<any>(`${ENV.baseUrl.api}${API.PASSWORDLESS}`, request, this.httpOptions);
  }
}
